import { MAX_TAILLE_MINIATURE } from '@/configuration/general/pieceJointeConf';
import Compressor from 'compressorjs';

export default async function compressionFichier(file) {
  // eslint-disable-next-line
  return await new Promise(resolve => {
    // eslint-disable-next-line
    new Compressor(file, {
      quality: 0.6,
      maxWidth: MAX_TAILLE_MINIATURE,
      maxHeight: MAX_TAILLE_MINIATURE,
      success(result) {
        resolve(result);
      },
      error() {
        resolve();
      },
    });
  });
}
